<template>
    <div class="card-info-table table-responsive">
        <table class="table inner-table mb-0">
            <thead>
            <tr>
                <th style="width:10%">Default</th>
                <th>Credit Card</th>
                <th>Billing Address</th>
                <th class="text-center" style="width:15%">Action</th>
            </tr>
            </thead>
            <tbody>
            <PaymentCardBillingItem
                v-for="payment in payment_accounts"
                ref="paymentCardBillingItem"
                :key="payment.id"
                :input_payment="payment"
                @destroy="deletePayment"
                @set-default="setDefault"
            >
            </PaymentCardBillingItem>
            </tbody>
        </table>
    </div>
</template>

<script>
    import PaymentCardBillingItem from "./PaymentCardBillingItem";

    export default {
        name: "PaymentCardBillingList",
        components: {
            PaymentCardBillingItem,
        },
        props: {
            paymentAccounts: {
                type: Array
            }
        },
        data() {
          return {
              payment_accounts: this.paymentAccounts
          }
        },
        methods: {
            deletePayment(id) {
                axios.delete(`/payments/accounts/${id}`)
                    .then(response => {
                        this.payment_accounts = response.data.paymentAccounts;
                        this.$emit('destroy', this.payment_accounts);
                    })
                    .catch(error => {
                        this.$swal.fire({
                            title: `Can not add your subscription!`,
                            text: error.response.data.message,
                            icon: 'error',
                        })
                    })
            },
            setDefault(id) {
                axios.put(`/payments/accounts/${id}/default`)
                    .then(response => {
                        $('.loader').hide();

                        this.payment_accounts = response.data.paymentAccounts;
                    })
                    .catch(error => {
                        console.log(error);
                        $('.loader').hide();
                    })
            }
        },
    }
</script>
